import { getQueue, putQueue, putPlayerInQueue } from 'actions'

export const fetchQueue = async (id) => {
  const res = await getQueue(id)
  return {
    type: 'GET_QUEUE_SUCCESS',
    data: res.queue
  }
}

export const addPlayerToQueue = (payload) => async (dispatch) => {
  const res = await putPlayerInQueue(payload)
  dispatch({
    type: 'ADD_PLAYER_TO_QUEUE_SUCCESS',
    data: res.queue
  })
  dispatch(await fetchQueue(payload.id))
}

export const updateQueue = async (payload) => {
  const res = await putQueue(payload)
  return {
    type: 'UPDATE_QUEUE_SUCCESS',
    data: res.data
  }
}
